export default __webpack_public_path__ + "static/media/07-lifestyle_preview.4c89763a.jpg";